import React from 'react';

const Footer = ({ theme }) => {
    return (
        <footer className={`pt-40 pb-10 px-6 transition-colors duration-500 ${theme === 'dark' ? 'bg-black' : 'bg-zinc-50'}`}>
            <div className="max-w-7xl mx-auto">
                {/* Reduced margin bottom here from mb-32 to mb-12 to bring the text closer */}
                <div className="flex flex-col md:flex-row justify-between items-start gap-20 mb-12">
                    <div className="max-w-xs">
                        <div className="flex items-center gap-3 mb-10">
                            <div className={`w-5 h-5 rounded-sm transition-colors ${theme === 'dark' ? 'bg-white' : 'bg-black'}`}></div>
                            <span className={`font-black text-lg tracking-tighter uppercase transition-colors ${theme === 'dark' ? 'text-white' : 'text-black'}`}>Kypser</span>
                        </div>
                        <p className="text-zinc-500 text-sm leading-relaxed font-medium">
                            Intelligence for high-end hospitality. <br />
                            Built with precision.
                        </p>
                    </div>

                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-20">
                        <div>
                            <h5 className={`text-[10px] uppercase tracking-widest font-black mb-8 transition-colors ${theme === 'dark' ? 'text-white' : 'text-black'}`}>Platform</h5>
                            <ul className="space-y-4 text-xs font-bold uppercase tracking-widest text-zinc-500">
                                <li><a href="/#features" className={`transition-colors ${theme === 'dark' ? 'hover:text-white' : 'hover:text-black'}`}>Overview</a></li>
                                <li><a href="/#platform" className={`transition-colors ${theme === 'dark' ? 'hover:text-white' : 'hover:text-black'}`}>Admin</a></li>
                                <li><a href="mailto:info@kypser.com?subject=Enterprise%20Inquiry" className={`transition-colors ${theme === 'dark' ? 'hover:text-white' : 'hover:text-black'}`}>Enterprise</a></li>
                            </ul>
                        </div>
                        <div>
                            <h5 className={`text-[10px] uppercase tracking-widest font-black mb-8 transition-colors ${theme === 'dark' ? 'text-white' : 'text-black'}`}>Company</h5>
                            <ul className="space-y-4 text-xs font-bold uppercase tracking-widest text-zinc-500">
                                <li><a href="mailto:info@kypser.com?subject=Ethics%20Question" className={`transition-colors ${theme === 'dark' ? 'hover:text-white' : 'hover:text-black'}`}>Ethics</a></li>
                                <li><a href="/privacy-policy.html" className={`transition-colors ${theme === 'dark' ? 'hover:text-white' : 'hover:text-black'}`}>Privacy</a></li>
                                <li><a href="mailto:info@kypser.com?subject=Support" className={`transition-colors ${theme === 'dark' ? 'hover:text-white' : 'hover:text-black'}`}>Support</a></li>
                            </ul>
                        </div>
                        <div>
                            <h5 className={`text-[10px] uppercase tracking-widest font-black mb-8 transition-colors ${theme === 'dark' ? 'text-white' : 'text-black'}`}>Legal</h5>
                            <ul className="space-y-4 text-xs font-bold uppercase tracking-widest text-zinc-500">
                                <li><a href="mailto:info@kypser.com?subject=Terms%20of%20Service" className={`transition-colors ${theme === 'dark' ? 'hover:text-white' : 'hover:text-black'}`}>Terms</a></li>
                                <li><a href="/privacy-policy.html" className={`transition-colors ${theme === 'dark' ? 'hover:text-white' : 'hover:text-black'}`}>Privacy</a></li>
                                <li><a href="/data-deletion.html" className={`transition-colors ${theme === 'dark' ? 'hover:text-white' : 'hover:text-black'}`}>Data Deletion</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Massive Footer Brand Text - Adjusted to prevent cutting and refine thickness */}
            <div className="w-full select-none mb-6 flex justify-center">
                <h2 className={`text-[15.2vw] font-medium tracking-[-0.03em] leading-none text-center whitespace-nowrap transition-colors ${theme === 'dark' ? 'text-white' : 'text-black'}`}>
                    KYPSER SUITE
                </h2>
            </div>

            <div className="max-w-7xl mx-auto">
                <div className={`flex flex-col md:flex-row justify-between items-center pt-8 border-t gap-6 text-[10px] font-black uppercase tracking-widest transition-colors ${theme === 'dark' ? 'border-zinc-900 text-zinc-600' : 'border-zinc-200 text-zinc-400'}`}>
                    <p>&copy; 2025 Kypser Intelligence Systems.</p>
                    <div className="flex gap-10">
                        <a href="/privacy-policy.html" className={`transition-colors ${theme === 'dark' ? 'hover:text-white' : 'hover:text-black'}`}>Privacy</a>
                        <a href="/data-deletion.html" className={`transition-colors ${theme === 'dark' ? 'hover:text-white' : 'hover:text-black'}`}>Data Deletion</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
